module.exports = __webpack_public_path__ + "img/button-POP-Assoc.0f8cbfcf.svg";